module.exports = __webpack_public_path__ + "static/media/gryphon_x_ids_prototypeexhibition_logos_white.f9db2021.svg";